import { WaterThermometerOutlineIcon } from './WaterThermometerOutlineIcon';

/**
 * author: Michael Irigoyen
 * id D69A4155-E2D7-4A9F-82CD-904D346E8A6E
 * name water-thermometer-outline
 * version: 6.7.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/water-thermometer-outline.svg
 * tags
 * - Weather 
 * - Home Automation 
 */
export const WaterTemperatureOutlineIcon = WaterThermometerOutlineIcon;
export default WaterTemperatureOutlineIcon